/**
 * Copyright © 2026 Mike Hall
 * Licensed under the GNU Affero General Public License v3.0.
 */
export const GAME_PHASES = [
    'StartTurn',
    'DeploymentPhase',
    'AttackPhase',
    'AttackResolution',
    'CleanupPhase',
    'ReinforcementPhase',
    'DrawPhase',
    'EndTurn',
    'gameOver',
];
export const ACTION_PHASES = ['DeploymentPhase', 'AttackPhase', 'ReinforcementPhase'];
const ACTION_PHASE_SET = new Set(ACTION_PHASES);
export function isGameOver(gs) {
    return gs.phase === 'gameOver';
}
export function isCompleted(gs) {
    return gs.phase === 'gameOver' || gs.outcome != null;
}
export function isActionPhase(gs) {
    return ACTION_PHASE_SET.has(gs.phase);
}
export function isDeploymentPhase(gs) {
    return gs.phase === 'DeploymentPhase';
}
export function isReinforcementPhase(gs) {
    return gs.phase === 'ReinforcementPhase';
}
export function isAttackResolution(gs) {
    return gs.phase === 'AttackResolution';
}
export function isStartTurn(gs) {
    return gs.phase === 'StartTurn';
}
//# sourceMappingURL=phase.js.map